import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";


import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer} from "../spinner";
import moment from "moment";
import { 
    // validaSoloNumero, 
    formatMoneda, validaMonto, 
    // formatoMonto 
} from "../../util/varios";
// import { numeroaLetra } from '../../util/NumeroaLetra';
export const IncluirAunmentoFondoAvance = (props) => {
    let op = require("../../../src/modulos/datos");
    let token = localStorage.getItem("jwtToken");
    const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
    // const idusuario = JSON.parse(localStorage.getItem("idusuario"));
    const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
    // const espiritu = JSON.parse(localStorage.getItem("espiritu"));
    const anioactu = JSON.parse(localStorage.getItem("anioactu"));
    // const anioefi = parseInt(localStorage.getItem("efiscalanio"));

    const [activate, setActivate] = useState(false);
    // const [deshabilitado, setDeshabilitado] = useState(false);
    // const [habiBot, setHabiBot] = useState(false);
    const [habiCta, setHabiCta] = useState(false);
    // const [habiRev, setHabiRev] = useState(false);
    const [activo, setActivo] = useState(true);
    const [operacion, setOperacion] = useState(0);
    // const [mostrar4, setMostrar4] = useState(false);
    // const [mostrar5, setMostrar5] = useState(false);
    const [datospre, setDatospre] = useState([]);
    const [anio, setAnio] = useState([]);
    const [valida, setValida] = useState(0);
    const [depart, setDepart] = useState(null);
    const [tip, setTip] = useState(null);
    const [ticomp, setTicomp] = useState(null);
    const [ubi, setUbi] = useState(null);
    const [pucc, setPucc] = useState(0);
    const [tituloapro, setTituloapro] = useState("");
    const [data, setData] = useState([]);
    const [body, setBody] = useState(null);
    // const [anioOrd, setAnioOrd] = useState(0);
    // const [idCheemi, setIdCheemi] = useState(0);
    const [idCtaBan, setIdCtaBan] = useState("");
    const [modifi, setModifi] = useState(false);
    const [proce, setProce] = useState(false);
    const [modifi1, setModifi1] = useState(false);
    const [proce1, setProce1] = useState(false);
    const [desde, setDesde] = useState(0);
    // const [habiConcep, setHabiConcep] = useState(false);
    // const [habiFecha, setHabiFecha] = useState(false);
    // const [mostrarUsuario, setMostrarUsuario] = useState(false);
    const [cambioDatos, setCambioDatos] = useState(false);
    // const [permiEliminar, setPermiEliminar] = useState(0);
    // const ip = JSON.parse(localStorage.getItem('ip'));
    // const mac = JSON.parse(localStorage.getItem('mac'));
    // const [fecha, setFecha] = useState(null);
    // const [fechaRev, setFechaRev] = useState(null);
    // const [tabs, setTabs] = useState({
    //     tab1: 'tab-pane fade show active',
    //     tab2: 'tab-pane',
    //     tab3: 'tab-pane',
    //     tab4: 'tab-pane',

    // })
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [mensajesino, setMensajesino] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [values, setValues] = useState({
        idcuenta: "",
        auxiliar: "",
        descripcionaux: "",
        idcategoriaprogramatica: "",
        idpuc: "",
        puc: "",
        categoria: "",
        disponibilidad: 0.0,
        montoinicial: 0.0,
        tipopartida: "",
    });
    // const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtFecha = useRef();
    // const txtIdprov = useRef();
    // const txtObservacion = useRef();
    // const txtNp = useRef();
    const txtCodigo = useRef();
    const txtCodigoF = useRef();

    // const txtCedurifprov = useRef();
    // const txtNombreprov = useRef();
    const txtConcepto = useRef();
    // const txtIdCuenta = useRef();
    // const txtNomBanco = useRef();
    // const txtNumCuenta = useRef();
    // const txtNumTransferencia = useRef();
    const cmbAnio = useRef();
    const txtMontoDisponible = useRef();
    // const txtMontoPagar = useRef();
    // const txtFechaReverso = useRef();
    // const txtMotivo = useRef();
    // const edad = parseInt(moment.utc(fechaSistema).format('YYYY')) - 18;
    // const limiteEdad = edad + '-' + moment.utc(fechaSistema).format('MM-DD').toString();
    // const cmbGasto = useRef();
    const onChange = (e) => {
        if (e.target.id === "anio") {
            /* if (e.target.value > anioactu) {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "¡El Año no debe ser Mayor a los Anteriores!",
                    icono: "error",
                });
                cmbAnio.current.value = "";
                setAnio(0);
            } else { */
                setAnio(e.target.value);
            /* } */
        } else if (e.target.id === 'inputMotivo') {
            e.target.value = e.target.value.toUpperCase();
        }
    };
    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtCodigoF.current.value.trim() === "") {

            setMensaje({ mostrar: true, titulo: "Notificación", texto: "Favor Ingrese el N° de Fondo de Avance.", icono: "informacion", });
            sigue = false;
            txtCodigoF.current.focus();

        } else if (txtConcepto.current.value.trim() === "") {

            setMensaje({ mostrar: true, titulo: "Notificación", texto: "Favor Ingrese la Descripción", icono: "informacion", });
            sigue = false;
            txtConcepto.current.focus();

        } else if (txtMontoDisponible.current.value.trim() === "") {

            setMensaje({ mostrar: true, titulo: "Notificación", texto: "Favor Ingrese el Monto", icono: "informacion", });
            sigue = false;
            txtMontoDisponible.current.focus();
        }
        if (sigue) {
            setBody({
                operacion: operacion,
                nid: txtCodigo.current.value !== '' ? txtCodigo.current.value : 0,
                nidfondo: props.idfondo,
                fech: txtFecha.current.value,
                nro: txtCodigoF.current.value,
                descr: txtConcepto.current.value,
                mont: txtMontoDisponible.current.value.replace(/\./g, "").replace(",", "."),
                idefi: idefiscal
            });
            let msg = "";
            setDesde(0);
            if (props.operacion === 1) {
                msg = 'Esta Seguro de Registrar?.';
            } else if (props.operacion === 2) {
                msg = 'Esta Seguro de Reversar?.';
            } else if (props.operacion === 3) {
                msg = 'Esta Seguro de Eliminar?.';
            }
            setMensajesino({ mostrar: true, titulo: "Confirmación.", texto: msg, icono: "confirmacion", });
        }
    };
    const Actualizar = () => {
        let endpoint = `${op.conexion}/api/administracion/actualizarasignacion`;
        setActivate(true);
        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Operación Exitosa.', icono: 'exito' });
                    props.renderAsig({idfondo:props.idfondo,tabla:1})
                    props.onHideCancela();
                }
                setActivate(false);
            }).catch(function (error) {
                setActivate(false);
                setMensaje({ mostrar: true, titulo: "Error", texto: error.response.data.message, icono: "error" });
            });
    };
    const cancelar = () => {
        props.onHideCancela();
    };

    const blanquear = () => {
        setValues({
            idcuenta: "",
            auxiliar: "",
            descripcionaux: "",
            idcategoriaprogramatica: "",
            idpuc: "",
            puc: "",
            categoria: "",
            disponibilidad: 0.0,
            montoinicial: 0.0,
            tipopartida: "",
        });
        setDatospre([]);
        setActivate(false);
        setIdCtaBan("");
        setValida(0);
        setDepart(null);
        setTip(null);
        setUbi(null);
        setPucc(0);
        setData([]);
        setTicomp(null);
        setBody(null);
        setAnio(0);
        setTituloapro("");
        setActivo(true);
        setModifi(false);
        setProce(false);
        setModifi1(false);
        setProce1(false);
        setHabiCta(false);
        setCambioDatos(false);
    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        Actualizar()

    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        props.onHideRenderizar();
        props.onHideCancelar();
        blanquear();
    };

    const cerrarMensaje = () => {
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        if (desde === 8) {
            if (props.operacion === 1) {

                //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Compromiso Registrado Correctamente', icono: 'exito' });
                setDesde(2);
                setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Desea Imprimir En este Momento Comprobante de Egreso?', icono: 'confirmacion' });

            } else if (props.operacion === 2) {

                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El Egreso N° ' + txtCodigo.current.value + ' fué Reversado', icono: 'exito' });
            } else if (props.operacion === 3) {

                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'El Egreso N° ' + txtCodigo.current.value + ' fué Eliminado', icono: 'exito' });
            }
        }
    };


    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof event.which === "undefined") {
            /* if (
                event.target.value === "" ||
                parseFloat(
                    event.target.value.trim().replace(/\./g, "").replace(",", ".")
                ) === 0.0
            ) {
                event.target.value = "0,00";
            } */
            event.target.value = event.target.value


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false; //alert(e.which);
    };


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion)

                if (props.operacion !== 1) {
                    setValues(props.values);
                    console.log(props.values)
                } else {
                    setValues()
                }
            }}
        >
            <Modal.Header className="azulGradiant header-modal">
                <div className="fw-bold text-light">
                    <h3> {operacion === 1 ? "Registrar Fondo en Avance" : operacion === 2 ? "Reversar Fondo en Avance" : operacion === 3 ? "Eliminar Fondo en Avance" : "Consultar Fondo en Avance"}</h3>
                </div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}><i className="far fa-window-close"></i></button>
            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div>
                    <fieldset className="row border-azul rounded mx-auto container mb-1">




                        <div className="input-group input-group-sm col-md-3 mb-1">
                            <label className="input-group-text" id="inputGroup-sizing-sm"> Código: </label>
                            <input type="text" className="form-control text-uppercase" defaultValue={values ? values.idaumentofondoavance : ''} name="observacion" disabled={true} ref={txtCodigo} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                        </div>



                        <div className="col-md-5"></div>

                        <div className="input-group input-group-sm col-md-4 mb-1">
                            <label className="input-group-text" id="inputGroup-sizing-sm"> Fecha: </label>
                            <input type="date" className="form-control text-uppercase" disabled ref={txtFecha} defaultValue={values && values.fecha !== '' ? moment.utc(values.fecha).format('YYYY-MM-DD') : moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                        </div>

                        <div className="input-group input-group-sm col-md-5 mb-1">
                            <label className="input-group-text" id="inputGroup-sizing-sm"> N° Fondo en Avance: </label>
                            <input type="text" className="form-control text-uppercase" name="observacion" ref={txtCodigoF} disabled={operacion === 1 || operacion === 2 ? false : true} defaultValue={values && values.nrofondo ? values.nrofondo.trim() : ""} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                        </div>

                        <div className="col-md-7"></div>

                        <div className="col-md-12 mb-1">
                            <div className="input-group input-group-sm m-0 w-100">
                                <label className="input-group-text" id="inputGroup-sizing-sm"> Descripción: </label>
                                <textarea type="textarea" disabled={operacion === 1 || operacion === 2 ? false : true} style={{ height: 70 }} className="form-control text-uppercase" name="observacion" onChange={onChange} ref={txtConcepto} defaultValue={values && values.descripcion ? values.descripcion.trim() : ""} placeholder="Descripción del Concepto" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                            </div>
                        </div>
                        <div className="col-md-3 ml-auto">
                            <div className="input-group input-group-sm m-0 w-100">
                                <label className="input-group-text  fw-bold" id="inputGroup-sizing-sm"> Monto: </label>
                                <input type="text" className="form-control   text-right" ref={txtMontoDisponible} disabled={operacion === 1 || operacion === 2 ? false : true} onChange={handleInputMontoChange} placeholder="0,00" aria-label="Sizing example input" defaultValue={values && values.monto ? formatMoneda(
                                    values.monto.toString().replace(",", "").replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                ) : ""} aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                            </div>
                        </div>

                    </fieldset>





                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={onChangeValidar} disabled={props.operacion === 4 ? true : false} className="btn btn-success btn-sm rounded-pill fw-bold"><i className="far fa-check-circle"></i> Aceptar </button>
                <button type="button" /*ref={btnCancela}*/ onClick={cancelar} className="btn btn-sm btn-danger rounded-pill fw-bold"> <i className="fas fa-window-close"></i> Cancelar </button>

            </Modal.Footer>

            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === "Exito."
                        ? cerrarModal()
                        : cerrarMensaje();
                }}
            />
            <MensajeSiNo
                mensaje={mensajesino}
                onHideNo={() => {
                    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
                   
                }
                }
                onHideSi={handleCloseSi}
            />
        </Modal >
    );
};
